import React from "react";
import PropTypes from "prop-types";

import LogoTitle from "../../../LogoTitle/LogoTitle";
import logoPhone from "../../../../../images/icon_celular.svg";
import FloatLabel from "../../../FloatLabel/FloatLabel";

const SmsCodeForm = ({ msisdn, smsCode, setSmsCode }) => {
  return (
    <>
      <LogoTitle src={logoPhone} alt="Telefone" text={`Digite o código enviado para ${msisdn}`} />
      <FloatLabel
        type="tel"
        placeholder="Digite o código"
        size={5}
        maxLength={5}
        onChange={e => {
          setSmsCode(e.target.value.replace(/\D/g, ""));
        }}
        value={smsCode}
        autoFocus
      />
    </>
  );
};

SmsCodeForm.propTypes = {
  msisdn: PropTypes.string.isRequired,
  smsCode: PropTypes.string.isRequired,
  setSmsCode: PropTypes.func.isRequired,
};

export default SmsCodeForm;
